export class EmpresaResulthLocalConnectRequest {
  utilizaResulthLocalConnect: boolean;
}
